import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "action-card" };
const _hoisted_2 = { class: "action-card-head" };
const _hoisted_3 = {
    key: 0,
    class: "action-id"
};
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "type-buttons" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "form-row" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = { class: "final-action" };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "final-action" };
const _hoisted_18 = { key: 2 };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = { class: "final-action" };
const _hoisted_21 = { class: "card-actions" };
import { ref, computed, onMounted } from 'vue';
// Well-known app screens, shared with MovesPage's move-action picker
export const APP_SCREEN_OPTIONS = [
    { value: "appscreen/Finance", text: "Finances (no nav bar)" },
    { value: "appscreen/Home/Finance", text: "Finances (with nav bar)" },
    { value: "appscreen/Spending", text: "Spending (no nav bar)" },
    { value: "appscreen/Spending/Plan", text: "Spending plan (no nav bar)" },
    { value: "appscreen/Spending/TransactionTagging", text: "Transaction tagging" },
    { value: "appscreen/Home/Spending", text: "Spending (nav bar)" },
    { value: "appscreen/Home/Spending/Plan", text: "Spending plan (nav bar)" },
    { value: "appscreen/Home/Plan", text: "Plan your finances (nav bar)" },
    { value: "appscreen/Plan", text: "Plan your finances (no nav bar)" },
    { value: "appscreen/Plan/[pillar name]", text: "Plan pillar (replace name exactly, spaces ok)" },
    { value: "appscreen/Home/Resources/Guide", text: "Guide in resources" },
    { value: "appscreen/Home/Resources/Marketplace", text: "Marketplace in resources" },
    { value: "appscreen/Home/Resources/Calculators", text: "Calculators in resources" },
    { value: "appscreen/Home/Resources/Calculators/[calculator type]", text: "List of calculators for type (exact type from calculator tag)" },
    { value: "appscreen/Home/Resources/Benefits", text: "Benefits in resources" },
    { value: "appscreen/Goals", text: "Savings Goals" },
    { value: "appscreen/Questionnaires/InBest", text: "InBest" },
    { value: "appscreen/Questionnaires/", text: "Questionnaire" },
    { value: "appscreen/WellbeingHub", text: "Wellbeing Home" },
    { value: "appscreen/WellbeingHub/Stats", text: "Wellbeing Stats" },
    { value: "appscreen/WellbeingHub/Resilience", text: "Financial Resilience Page" },
    { value: "appscreen/ConnectBankAccount", text: "Connect bank account" },
    { value: "/MortgageDetails", text: "Add Mortgage" },
    { value: "appscreen/Finances/Accounts/Debt", text: "Debt accounts" },
    { value: "appscreen/Finances/Accounts/CreditCard", text: "Credit card accounts" },
    { value: "appscreen/Finances/Accounts/Current", text: "Current accounts" },
    { value: "appscreen/Finances/Accounts/BankSavings", text: "Bank savings accounts" },
    { value: "appscreen/Finances/Accounts/Mortgage", text: "Mortgage accounts" },
    { value: "appscreen/Finances/Accounts/Pension", text: "Pension accounts" },
    { value: "appscreen/Finances/Accounts/Investment", text: "Investment accounts" },
    { value: "appscreen/Finances/Accounts/Will", text: "Will accounts" },
    { value: "appscreen/Finances/Accounts/Insurance", text: "Insurance accounts" }
];
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppActionCard',
    props: {
        action: {}
    },
    emits: ["delete"],
    setup(__props, { emit: __emit }) {
        /* eslint-disable vue/no-mutating-props -- `action` is a live row from psm.actions; editing it in place is the intended data flow */
        const props = __props;
        const emit = __emit;
        const actionType = ref(null);
        const isQuestionnaireScreen = computed(() => props.action.appScreen != null &&
            props.action.appScreen.includes('Questionnaires') &&
            !props.action.appScreen.includes('InBest'));
        function setActionType() {
            actionType.value = null;
            if (props.action.appScreen != null && props.action.appScreen !== '')
                actionType.value = 'appScreen';
            if (props.action.cmsPage != null && props.action.cmsPage !== '')
                actionType.value = 'cmsPage';
            if (props.action.externalURL != null && props.action.externalURL !== '')
                actionType.value = 'externalURL';
        }
        function updateAction(at) {
            actionType.value = at;
            if (at === 'appScreen') {
                props.action.cmsPage = '';
                props.action.externalURL = '';
            }
            if (at === 'cmsPage') {
                props.action.appScreen = '';
                props.action.externalURL = '';
            }
            if (at === 'externalURL') {
                props.action.cmsPage = '';
                props.action.appScreen = '';
            }
        }
        // appScreen format: appscreen/Questionnaires/{key}/{questionsPerPage}
        function onQuestionnaireKeyInput(e) {
            const key = e.target.value;
            const arr = props.action.appScreen.split('/');
            const qpp = arr[3] != null && arr[3] !== '' && arr[3] !== 'undefined' && key !== 'InBest' ? '/' + arr[3] : '';
            props.action.appScreen = 'appscreen/Questionnaires/' + key + qpp;
        }
        function onQuestionsPerPageInput(e) {
            const qpp = e.target.value;
            const arr = props.action.appScreen.split('/');
            props.action.appScreen = 'appscreen/Questionnaires/' + arr[2] + '/' + qpp;
        }
        onMounted(setActionType);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", null, "Action", -1)),
                    (_ctx.action.id)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_3, "ID: " + _toDisplayString(_ctx.action.id), 1))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", null, "CTA:", -1)),
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.action.cta) = $event)),
                        type: "text",
                        class: "form-input"
                    }, null, 512), [
                        [_vModelText, _ctx.action.cta]
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "1)", -1)),
                    _createElementVNode("button", {
                        class: _normalizeClass(["action-btn", actionType.value === 'appScreen' ? 'primary' : 'secondary']),
                        onClick: _cache[1] || (_cache[1] = ($event) => (updateAction('appScreen')))
                    }, "App Screen", 2),
                    _createElementVNode("button", {
                        class: _normalizeClass(["action-btn", actionType.value === 'cmsPage' ? 'primary' : 'secondary']),
                        onClick: _cache[2] || (_cache[2] = ($event) => (updateAction('cmsPage')))
                    }, "CMS Page", 2),
                    _createElementVNode("button", {
                        class: _normalizeClass(["action-btn", actionType.value === 'externalURL' ? 'primary' : 'secondary']),
                        onClick: _cache[3] || (_cache[3] = ($event) => (updateAction('externalURL')))
                    }, "Website URL", 2)
                ]),
                (actionType.value === 'appScreen')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "step-hint" }, "2) Choose a well known app screen from the dropdown, or enter it manually in the text box.", -1)),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _cache[12] || (_cache[12] = _createElementVNode("label", null, "Select:", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.action.appScreen) = $event)),
                                    class: "form-input"
                                }, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(APP_SCREEN_OPTIONS, (opt) => {
                                        return _createElementVNode("option", {
                                            key: opt.value,
                                            value: opt.value
                                        }, _toDisplayString(opt.text), 9, _hoisted_9);
                                    }), 64))
                                ], 512), [
                                    [_vModelSelect, _ctx.action.appScreen]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Manual:", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.action.appScreen) = $event)),
                                    type: "text",
                                    class: "form-input"
                                }, null, 512), [
                                    [_vModelText, _ctx.action.appScreen]
                                ])
                            ])
                        ]),
                        (isQuestionnaireScreen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "3) Questionnaire Key:", -1)),
                                    _createElementVNode("input", {
                                        type: "text",
                                        class: "form-input",
                                        onInput: onQuestionnaireKeyInput
                                    }, null, 32)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _cache[15] || (_cache[15] = _createElementVNode("label", null, "4) Number of questions per page:", -1)),
                                    _createElementVNode("input", {
                                        type: "text",
                                        class: "form-input",
                                        onInput: onQuestionsPerPageInput
                                    }, null, 32)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                            _cache[16] || (_cache[16] = _createTextVNode("Final Action (admin): ")),
                            _createElementVNode("p", null, _toDisplayString(_ctx.action.appScreen), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (actionType.value === 'cmsPage')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _cache[18] || (_cache[18] = _createElementVNode("label", null, "2) CMS Page Key:", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.action.cmsPage) = $event)),
                                type: "text",
                                class: "form-input"
                            }, null, 512), [
                                [_vModelText, _ctx.action.cmsPage]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _cache[19] || (_cache[19] = _createTextVNode("Final Action (admin): ")),
                            _createElementVNode("p", null, _toDisplayString(_ctx.action.cmsPage), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (actionType.value === 'externalURL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", null, "2) Website URL:", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.action.externalURL) = $event)),
                                type: "text",
                                class: "form-input"
                            }, null, 512), [
                                [_vModelText, _ctx.action.externalURL]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _cache[21] || (_cache[21] = _createTextVNode("Final Action (admin): ")),
                            _createElementVNode("p", null, _toDisplayString(_ctx.action.externalURL), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                        class: "action-btn danger",
                        onClick: _cache[8] || (_cache[8] = ($event) => (emit('delete')))
                    }, "Delete Action")
                ])
            ]));
        };
    }
});
